module.exports = __webpack_public_path__ + "static/computer-7066fac0e4ac450782daea3fdffa237f.svg";